"use client";

import React, { Suspense } from "react";
import NavigationLoader from "../NavigationLoader";
import Loading from "../Loading";
import AppInitializer from "../AppInitializer";
import InstallPrompt from "../../pwa/InstallPrompt";
import UpdatePrompt from "../../pwa/UpdatePrompt";
import NetworkStatus from "../../pwa/NetworkStatus";
import useIOSViewportFix from "../../../hooks/useIOSViewportFix";
import { PullToRefreshProvider } from "../../providers/PullToRefreshProvider";

interface ClientWrapperProps {
  children: React.ReactNode;
}

const ClientWrapper: React.FC<ClientWrapperProps> = ({ children }) => {
  // Apply iOS viewport fixes
  useIOSViewportFix();

  return (
    <AppInitializer>
      <PullToRefreshProvider>
        <Suspense fallback={null}>
          <NavigationLoader />
        </Suspense>
        <Suspense fallback={
          <div className="flex items-center justify-center min-h-screen">
            <Loading text="Đang tải..." />
          </div>
        }>
          {children}
        </Suspense>
        {/* PWA Components */}
        <InstallPrompt />
        <UpdatePrompt />
        <NetworkStatus />
      </PullToRefreshProvider>
    </AppInitializer>
  );
};

export default ClientWrapper;